module.exports = "<div class=\"wrapper\">\n    <!-- top navbar-->\n    <app-header class=\"topnavbar-wrapper\"></app-header>\n    <!-- sidebar-->\n    <app-sidebar class=\"aside\"></app-sidebar>\n    <section>\n        <!-- Page content-->\n        <div class=\"content-wrapper\">\n            <router-outlet></router-outlet>\n        </div>\n    </section>\n    <!-- Page footer-->\n    <footer app-footer></footer>\n</div>\n<toaster-container [toasterconfig]=\"toasterconfig\"></toaster-container>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/layout.component.html
// module id = ./src/app/layout/layout.component.html
// module chunks = main